/* @flow */

// import { get, mapKeys, reduce, camelCase } from 'lodash';

import designRoutines from '../routines/design';

import { setIn } from '../utils';
import { constants } from '../actions/design';

export type Record = any;

export type RecordsType = {
  current: ?number,
  data: Map<number, Record>,
  loading: boolean,
};

export type StateType = {
  generatingReport: boolean,
  records: RecordsType,
};

// Reducer
export const initialState: StateType = {
  records: {
    loading: false,
    current: null,
    error: '',
    data: new Map(),
  },
  generatingReport: false,
};

export default function (state: StateType = initialState, action: any): StateType {
  switch (action.type) {
    case constants.REQUEST_PDF: {
      return {
        ...state,
        generatingReport: true,
      };
    }

    case constants.RECEIVE_PDF: {
      return {
        ...state,
        generatingReport: false,
      };
    }

    case 'Design/NEW_DESIGN': {
      return initialState;
    }

    case designRoutines.updateRecordName.SUCCESS:
    case designRoutines.deleteDesign.SUCCESS:
    case designRoutines.fetchAllRecords.SUCCESS: {
      // Convert the record array to a Map
      // $FlowIgnore
      let response = action.payload.response;
      if (!response) return state;

      // hacky
      if (response && response[0] && response[0].activityId) {
        response = response.map((r) => {
          const o = r;
          o.id = r.activityId;
          o.name = r.recordName;
          o.timestamp = r.activityDttm;

          delete o.activityId;
          delete o.recordName;
          delete o.activityDttm;

          return o;
        });
      }

      const arr = response.map(record => [record.id || record.activityId, record]);
      const map: Map<number, Record> = new Map(arr);
      return setIn('records.data', map, state);
    }

    case designRoutines.fetchRecord.TRIGGER: {
      return setIn('records.current', Number(action.payload), state);
    }

    case designRoutines.copyDesign.SUCCESS:
    case designRoutines.saveDesignRecord.SUCCESS: {
      // $FlowIgnore
      const response = action.payload.response;
      if (!response) return state;

      const id = response.id || response[0].id;
      const data = response.data || response;

      // $FlowIgnore
      const arr = data.map(record => [record.id, record]);
      const map: Map<number, Record> = new Map(arr);

      const dataState = setIn('records.data', map, state);

      // skip updating the current design if the modal is open (we're managing)
      // $FlowIgnore
      if (action.payload.fromModal) return dataState;

      return setIn('records.current', id, dataState);
    }

    // Save Design
    case designRoutines.updateRecordName.TRIGGER:
    case designRoutines.copyDesign.TRIGGER:
    case designRoutines.deleteDesign.TRIGGER:
    case designRoutines.fetchAllRecords.TRIGGER:
    case designRoutines.saveDesignRecord.TRIGGER: {
      return setIn('records.loading', true, state);
    }

    case designRoutines.updateRecordName.FAILURE:
    case designRoutines.copyDesign.FAILURE:
    case designRoutines.deleteDesign.FAILURE:
    case designRoutines.saveDesignRecord.FAILURE: {
      return setIn('records.error', action.payload, state);
    }

    case 'HIDE_MODAL': {
      return {
        ...state,
        records: {
          ...state.records,
          loading: false,
          error: '',
        },
      };
    }

    case designRoutines.updateRecordName.FULFILL:
    case designRoutines.copyDesign.FULFILL:
    case designRoutines.deleteDesign.FULFILL:
    case designRoutines.fetchAllRecords.FULFILL:
    case designRoutines.saveDesignRecord.FULFILL: {
      return setIn('records.loading', false, state);
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/global.js